
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import {
        ApplicationActions,
        EditDocumentSeedRequest,
        EditOpenSeaPilotCertificateSeedRequest,
        ResultError,
        AreasClient,
        OpenSeaPilotCertificateDocumentApiModel,
        AreaOption
    } from "@/api-client";
    import IssueDocumentInnerComponent from "@/features/applications/components/issue-document/IssueDocumentInnerComponent";
    import IssueDocumentSignature from "@/features/applications/components/issue-document/IssueDocumentSignature.vue";
    import DatePicker from "@/components/DatePicker.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import AdditionalInfoButton from "@/features/shared/components/AdditionalInfoButton.vue";
    import Multiselect from "vue-multiselect";

    @Component({
        components: {
            AdditionalInfoButton,
            DatePicker,
            IssueDocumentSignature,
            LabelOptional,
            Multiselect
        }
    })
    export default class IssueOpenSeaPilotCertificate extends IssueDocumentInnerComponent {
        @Prop({required: true})
        issueDocumentDetails!: OpenSeaPilotCertificateDocumentApiModel;
        @Prop({required: true})
        actions!: ApplicationActions;
        @Prop({required: true})
        errors!: ResultError;

        initialEditModel!: EditDocumentSeedRequest;
        areasClient = new AreasClient();

        validUntil = this.issueDocumentDetails.validUntil;
        issueDate = this.issueDocumentDetails.issueDate;
        additionalInfo = this.issueDocumentDetails.additionalInfo;
        selectedPilotageAreas: AreaOption[] = [];
        pilotageAreaOptions: AreaOption[] = [];

        async mounted() {
            await this.loadPilotageAreas();

            // Initialize selected pilotage areas from existing data after options are loaded
            if (this.issueDocumentDetails.pilotageAreaIds && this.issueDocumentDetails.pilotageAreaIds.length > 0) {
                this.selectedPilotageAreas = this.pilotageAreaOptions.filter(option =>
                    this.issueDocumentDetails.pilotageAreaIds.includes(option.value)
                );
            }

            this.initialEditModel = this.getEditModel();
        }

        async loadPilotageAreas() {
            const response = await this.areasClient.pilotageAreaOptions();
            this.pilotageAreaOptions = response.areas;
        }

        getEditModel(): EditDocumentSeedRequest {
            const request = new EditOpenSeaPilotCertificateSeedRequest();
            request.additionalInfo = this.additionalInfo;
            request.issueDate = this.issueDate;
            request.validUntil = this.validUntil;
            request.pilotageAreaIds = this.selectedPilotageAreas.map(area => area.value);
            return request;
        }
    }
